const actions = {
  SET_STATE: 'user/SET_STATE',
   EDIT: 'contract/EDIT',
}

export default actions
